import { useRef, useState, useEffect } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router';
import {
	Box,
	ButtonBase,
	ListItemIcon,
	ListItemText,
	Typography,
	MenuItem,
	Popover,
} from '@mui/material';
import CogIcon from '../icons/Cog';
import UserIcon from '../icons/User';
import { getCurrentUser } from 'aws-amplify/auth';

const AccountPopover = ({ path, menuText }) => {
	const navigate = useNavigate();
	const anchorRef = useRef(null);
	const [open, setOpen] = useState(false);

	useEffect(() => {
		//deny unauthorized user access
		getCurrentUser()
			.then((user) => {
				// groups would need fetchAuthSession() if uncommented
			})
			.catch((err) => {
				navigate('/login');
			});
	}, []);


	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
	};

	return (
        <>
            <Box
				component={ButtonBase}
				onClick={handleOpen}
				ref={anchorRef}
				sx={{
					alignItems: 'center',
					display: 'flex',
					fontSize: '1rem',
				}}
			>
				メニュー
			</Box>
            <Popover
				anchorEl={anchorRef.current}
				anchorOrigin={{
					horizontal: 'center',
					vertical: 'bottom',
				}}
				keepMounted
				onClose={handleClose}
				open={open}
				slotProps={{
                    paper: {
                        sx: { width: 240 },
                    }
                }}
			>
				<Box sx={{ mt: 2 }}>
					<MenuItem
						component={RouterLink}
						to={path ? path.userPath : ''}
						onClick={handleClose}
					>
						<ListItemIcon>
							<UserIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primary={
								<Typography color="textPrimary" variant="subtitle2">
									{menuText}
								</Typography>
							}
						/>
					</MenuItem>
					<MenuItem
						component={RouterLink}
						to={path ? path.resetPasswordPath : ''}
						onClick={handleClose}
					>
						<ListItemIcon>
							<CogIcon fontSize="small" />
						</ListItemIcon>
						<ListItemText
							primary={
								<Typography color="textPrimary" variant="subtitle2">
									パスワード再設定
								</Typography>
							}
						/>
					</MenuItem>
				</Box>
			</Popover>
        </>
    );
};

export default AccountPopover;
